import { reactive } from 'vue'

export interface ConfirmOptions {
  /** 标题，默认「确认操作」 */
  title?: string
  /** 正文说明 */
  message: string
  /** 确认按钮文案，默认「确定」 */
  confirmText?: string
  /** 取消按钮文案，默认「取消」 */
  cancelText?: string
  /** 是否为危险操作（确认按钮用红色样式） */
  danger?: boolean
}

interface ConfirmState extends Required<ConfirmOptions> {
  open: boolean
}

// 单例状态：全局只渲染一个 ConfirmDialog，所有页面共享。
export const confirmState = reactive<ConfirmState>({
  open: false,
  title: '确认操作',
  message: '',
  confirmText: '确定',
  cancelText: '取消',
  danger: false,
})

let resolver: ((value: boolean) => void) | null = null

/**
 * 弹出确认框，返回 Promise<boolean>：用户点「确定」为 true，点「取消」/遮罩/ESC 为 false。
 * 用法：const ok = await confirm({ message: '确认删除？', danger: true }); if (!ok) return
 */
export function confirm(options: ConfirmOptions): Promise<boolean> {
  // 若已有未关闭的确认框，先以取消结算上一个，避免 resolver 泄漏。
  if (resolver) {
    respondConfirm(false)
  }
  confirmState.title = options.title ?? '确认操作'
  confirmState.message = options.message
  confirmState.confirmText = options.confirmText ?? '确定'
  confirmState.cancelText = options.cancelText ?? '取消'
  confirmState.danger = options.danger ?? false
  confirmState.open = true
  return new Promise<boolean>((resolve) => {
    resolver = resolve
  })
}

/** 供 ConfirmDialog 组件回传用户选择。 */
export function respondConfirm(value: boolean): void {
  confirmState.open = false
  const resolve = resolver
  resolver = null
  if (resolve) resolve(value)
}

export function useConfirm() {
  return { confirm }
}
